import { render, staticRenderFns } from "./studentifno-addstudent-upload.vue?vue&type=template&id=27ba029a&scoped=true"
import script from "./studentifno-addstudent-upload.vue?vue&type=script&lang=js"
export * from "./studentifno-addstudent-upload.vue?vue&type=script&lang=js"
import style0 from "./studentifno-addstudent-upload.vue?vue&type=style&index=0&id=27ba029a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba029a",
  null
  
)

export default component.exports